import { createRouter, createWebHistory } from 'vue-router'
import Layout from '../layout/layout.vue'
import frontEndService from '../Services/frontEndService.js'
import helpers from '../helpers/filters'


const routes = [
    {
        path: '',
        name: 'Layout',
        component: Layout,
        children: [
            {
                path: '',
                name: 'HomePageDefault',
                redirect: to => {
                    return { path: `/Home` }
                }
            },
            
            {
                path: 'Home/:DiscountCode?',
                name: 'HomePage',
                props: true,
                component: () => import('@/views/Home/HomePage.vue')
            },
            {
                path: 'mobileDashboard',
                name: 'mobileDashboard',
                component: () => import('@/views/MobileDashboard/mobileDashboard.vue')
            },
            {
                path: 'Aboutus',
                name: 'Aboutus',
                component: () => import('@/views/dynamicPages/dynamicPages.vue')
            },
            {
                path: '/RateCard',
                name: 'RateCard',
                component: () => import('@/views/GolfCartListing/RateCard.vue')
            },
            {
                path: ':url',
                name: 'dynamicPage',
                component: () => import('@/views/dynamicPages/dynamicPages.vue')
            },
            {
                path: 'Howitworks',
                name: 'Howitworks',
                component: () => import('@/views/dynamicPages/dynamicPages.vue')
            },
            {
                path: 'AssetLegalTerms/:Id',
                name: 'AssetLegalTerms',
                component: () => import('@/views/AssetLegalTerms/AssetLegalTerms.vue')
            },
            {
                path: 'PrivacyPolicy',
                name: 'PrivacyPolicy',
                component: () => import('@/views/dynamicPages/dynamicPages.vue')
            },
            {
                path: 'TermsandConditions',
                name: 'TermsandConditions',
                component: () => import('@/views/dynamicPages/dynamicPages.vue')
            },
            {
                path: 'SecurityDepositPolicy',
                name: 'SecurityDepositPolicy',
                component: () => import('@/views/dynamicPages/dynamicPages.vue')
            },
            {
                path: 'Scheduling',
                name: 'Scheduling',
                component: () => import('@/views/dynamicPages/dynamicPages.vue')
            },
            {
                path: 'Listings',
                name: 'Listings',
                component: () => import('@/views/ManageAsset/assetListing.vue')
            },
            {
                path: 'AssetDetail/:id',
                name: 'AssetDetail',
                component: () => import('@/views/ManageAsset/assetDetail.vue')
            },
            {
                path: 'AssetDetail',
                name: 'AssetDetails',
                component: () => import('@/views/ManageAsset/assetDetail.vue')
            },
            {
                path: 'sell',
                name: 'sell',
                component: () => import('@/views/dynamicPages/dynamicPages.vue')
            },
            {
                path: 'ambassador',
                name: 'ambassador',
                component: () => import('@/views/ManageMembership/membershipList.vue')
            },
            {
                path: 'membershipdetail/:id',
                name: 'membershipdetail',
                component: () => import('@/views/ManageMembership/membershipdetail.vue')
            },
            {
                path: 'thankyou',
                name: 'thankyou',
                component: () => import('@/views/ThankYou/thankyou.vue')
            },
            {
                path: 'contactus',
                name: 'ContactUs',
                component: () => import('@/views/contactus/contactus')
            },
            {
                path: 'pressnews',
                name: 'pressnews',
                component: () => import('@/views/News/news.vue')
            },
            {
                path: 'pressnewsdetail/:id',
                name: 'Press News Detail',
                component: () => import('@/views/News/newsdetail.vue')
            },
            {
                path: 'unsubscribenewsletter/:email',
                name: 'Unsubscribe Newsletter',
                component: () => import('@/views/shared/UnsubscribeNewsletter/unsubscribenewsletter.vue')
            },
            {
                path: 'unsubscribe/:email/:companyId',
                name: 'Unsubscribe',
                component: () => import('@/views/Unsubscribe/unsubscribe.vue')
            },
            {
                path: 'resetpassword',
                name: 'Set Password',
                component: () => import('@/views/SetPassword/setPassword.vue')
            },

            {
                path: 'assetcomparedetails',
                name: 'assetcomparedetails',
                component: () => import('@/views/ManageAsset/assetCompareDetails.vue')
            },
            {
                path: 'reviewslisting',
                name: 'ReviewsListing',
                component: () => import('@/views/ManageReviews/reviewsListing.vue')
            },
            {
                path: 'FAQ',
                name: 'FAQ',
                component: () => import('@/views/FrequentlyAskedQuestions/frequentlyAskedQuestionsAnswer.vue')
            },
            {
                path: 'clientRegistration',
                name: 'ClientRegistration',
                component: () => import('@/views/Registration/clientRegistration.vue')
            },
            {
                path: 'SignupPage',
                name: 'SignupPage',
                component: () => import('@/views/SignUpPage/SignupPage.vue')
            },
            {
                path: 'ForgotPassword',
                name: 'ForgotPassword',
                component: () => import('@/views/ForgotPassword/ForgotPassword.vue')
            },
            {
                path: 'Login',
                name: 'Login',
                component: () => import('@/views/Login/login.vue')
            },
            {
                path: 'Testimonials/:DiscountCode?',
                name: 'Testimonials',
                props: true,
                component: () => import('@/views/Testimonial/testimonialList.vue')
            },
            {
                path: 'Blog',
                name: 'Blog',
                component: () => import('@/views/Blog/blogList.vue')
            },
            {
                path: 'blogdetail/:id',
                name: 'Blog Detail',
                component: () => import('@/views/Blog/blogDetail.vue')
            },
            {
                path: 'VeteransVacation',
                name: 'VeteransVacation',
                component: () => import('@/views/VeteransVacations/veteransvacations.vue')
            },
            {
                path: 'AssetConfirm',
                name: 'Asset Confirm',
                component: () => import('@/views/AssetBuyConfirmation/Thankyou.vue')
            },
            {
                path: 'AssetRentConfirm',
                name: 'Asset Rent Confirm',
                component: () => import('@/views/AssetRentConfirmation/Thankyou.vue')
            },
            {
                path: 'iconic',
                name: 'Iconic Page',
                component: () => import('@/views/Iconic/iconic.vue')
            },
            {
                path: 'LandingPageThankYou',
                name: 'Landing Page Thank You',
                component: () => import('@/views/LandingPageThankYou/landingpagethankyou.vue')
            },
            {
                path: 'FrexiiCRM',
                name: 'FrexiiCRM',
                component: () => import('@/views/dynamicPages/dynamicPages.vue')
            },
            //10311Exchange
            {
                path: '10311Exchange',
                name: '10311Exchange',
                component: () => import('@/views/dynamicPages/dynamicPages.vue')
            },
            {
                path: 'ConfirmAndPay',
                name: 'ConfirmAndPay',
                component: () => import('@/views/ConfirmAndPay/ConfirmAndPay.vue')
            },
            {
                path: 'ConfirmAndPay2',
                name: 'ConfirmAndPay2',
                component: () => import('@/views/ConfirmAndPay/ConfirmPay2.vue')
            },
            {
                path: '/ConfirmPay',
                name: 'ConfirmPay',
                component: () => import('@/views/ManageAsset/hotelConfirmandpay.vue')
            },
            {
                path: 'Booking',
                name: 'Booking',
                component: () => import('@/views/ManageAsset/hotelListing.vue')
            },
            {
                path: '/bookingDetail/:Id',
                name: 'Booking Detail',
                component: () => import('@/views/ManageAsset/hotelDetail.vue')
            },
            {
                path: '/Experience',
                name: 'Experience',
                component: () => import('@/views/ManageAsset/StayandExperienceHome.vue')
            },
            {
                path: '/ExperienceDetails/:Id',
                name: 'ExperienceDetails',
                component: () => import('@/views/ManageExperience/ExperienceDetail.vue')
            },
            {
                path: '/bookingConfirmation',
                name: 'Booking Confirmation',
                component: () => import('@/views/ManageAsset/bookingConfirmation.vue')
            },
            {
                path: '/Hotel_Home',
                name: 'Hotel_Home',
                component: () => import('@/layout/Themes/ClassicTheme/Components/Home/Hotel_Home.vue')
            },
            {
                path: 'NearByMeLocation',
                name: 'NearByMeLocation',
                component: () => import('@/layout/Themes/CleanTheme/Views/ManageAsset/NearByMeLocation.vue')
            },
            {
                path: '/ExperienceFilter',
                name: 'ExperienceFilter',
                component: () => import('@/views/ManageAsset/experienceHomeFilter.vue')             
            },
            {
                path: '/StayFilter',
                name: 'StayFilter',
                component: () => import('@/views/ManageAsset/StayHomeFilters.vue')
                /*component: () => import('@/layout/Themes/ExperienceTheme/Components/Home/StayHomeFilters.vue')*/
            },
            {
                path: '/StayDetails/:Id',
                name: 'Stay Detail',
                component: () => import('@/views/ManageAsset/StayDetails.vue')
            },
            //  {
            //    path: '/StayDetails',
            //      name: 'StayDetails',
            //      component: () => import('@/layout/Themes/ExperienceTheme/Views/ExperienceDetails/StayDetails.vue')
            //},
            {
                path: '/ExperienceConfirmPay',
                name: 'ExperienceConfirmPay',
                component: () => import('@/views/ManageAsset/experienceCoinfirmation.vue')
            },
            {
                path: '/StayConfirmPay',
                name: 'StayConfirmPay',
                component: () => import('@/views/ManageAsset/stayConfirmation.vue')
            },
            {
                path: '/StayConfirm',
                name: 'Stay Confirm',
                component: () => import('@/views/ManageAsset/stayConfirmDetail.vue')
            },
              {
                  path: '/ExperienceConfirmBooking',
                  name: 'Experience Confirm',
                  component: () => import('@/views/ManageAsset/experienceConfirmDetail.vue')
            },
            {
                path: '/GolfCartListing',
                name: 'GolfCartListing',
                component: () => import('@/views/GolfCartListing/GolfCart_Listing.vue')
            },
            {
                path: '/GolfCartListDetail/:Id',
                name: 'Golf Cart Detail',
                component: () => import('@/views/GolfCartListDetail/GolfCartListDetails.vue')

            },
            {
                path: '/home/GolfCartListDetail/:Id',
                name: 'Golf Cart Rental Detail',
                component: () => import('@/views/GolfCartListDetail/GolfCartListDetails.vue')

            },
            {
                path: '/GolfCartRentalPayment',
                name: 'GolfCart Rental Payment',
                component: () => import('@/views/GolfCartRental/GolfCartRentalPayment.vue')
            },
            {
                path: '/payment-thankyou',
                name: 'Thanku for booking',
                component: () => import('@/views/ThankYou/paymentthanku.vue')
            },
            {
                path: '/thankyou-newsletter',
                name: 'thankyou-newsletter',
                component: () => import('@/views/ThankYou/thankyounewsletter.vue')
            },
            {
                path: '/unsubscribe',
                name: 'thankyou-newsletter',
                component: () => import('@/views/ThankYou/unsubscribe.vue')
            },
            {
                path: '/thankyou-signup',
                name: 'thankyou-signup',
                component: () => import('@/views/ThankYou/thankyousignup.vue')
            },
            {
                path: '/GolfCartRentalConfirm',
                name: 'GolfCart Rental Confirm',
                component: () => import('@/views/GolfCartRental/GolfCartRentalConfirm.vue')
            },
            {
                path: '/restaurantDetail/:Id',
                name: 'Restaurant Detail',
                component: () => import('@/views/ManageAsset/restaurantDetail.vue')

            },
            {
                path: '/RestaurantConfirmation',
                name: 'Restaurant Confirmation',
                component: () => import('@/views/ManageAsset/RestaurantConfirmPay.vue')
            },
            {
                path: '/RestaurantConfirm',
                name: 'Restaurant Confirm',
                component: () => import('@/views/ManageAsset/restaurantConfirm.vue')
            },
             {
                path: '/SpaConfirmPay',
                 name: 'Spa ConfirmPay',
                 component: () => import('@/views/ManageAsset/SpaServiceConfirmPay.vue')
            },
             {
                path: '/SpaConfirm',
                name: 'Spa Confirm',
                component: () => import('@/views/ManageAsset/SpaServiceBookingConfirm.vue')
            },
             {
                 path: '/SpaBookingDetail/:Id',
                 name: 'Spa BookingDetail',
                component: () => import('@/views/ManageAsset/SpaServiceDetail.vue')
            },
            {
                path: '/Cart',
                name: 'Cart',
                component: () => import('@/views/Cart/Cart.vue')
            },
            {
                path: '/GolfCartRentalConfirm/:Id',
                name: 'GolfCart Rental Confirmation',
                component: () => import('@/views/GolfCartRental/GolfCartRentalConfirm_Backup.vue')
            },
            {
                path: '/GolfCartListDetail/:Id/:DiscountCode',
                name: 'GolfCartDetail DiscountCode',
                component: () => import('@/views/GolfCartListDetail/GolfCartListDetails.vue')

            },
            {
                path: '/Cart/:DiscountCode',
                name: 'Cart DiscountCode',
                component: () => import('@/views/Cart/Cart.vue')
            },
            {
                path: '/GolfCartBookingConfirmation/:Id',
                name: 'Cart Booking Confirmation',
                component: () => import('@/views/GolfCartBookingConfirmation/golfCartBookingConfirmation.vue')
            }

        ]
    },
    {
        path: '/logoutRedirect/:origin',
        name: 'logoutRedirect',
        component: () => import('../layout/LogoutRedirect.vue')
    },
    {
        path: '/errorPage',
        name: 'errorPage',
        component: () => import('@/views/ErrorPage/errorPage.vue')
    }
    
    
];

//Global Arrays For Dynamic Menu
let HeaderNavlinks = []
let FooterNavlinks = []
const router = createRouter({
    history: createWebHistory(),
    routes, HeaderNavlinks, FooterNavlinks,
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return new Promise((resolve) => {
                setTimeout(() => {
                    const el = document.querySelector(to.hash)
                    if (el) {
                        el.scrollIntoView({ behavior: 'smooth' })
                    }
                    resolve()
                }, 500) // wait for async content
            })
        }
        return { top: 0 }
    }
})


function createMenuItems(menuList) {
    return menuList.map(item => {
        const matchingRoute = routes[0].children.find(route => route.name === item.routeUrl);
        return {
            routeUrl: matchingRoute ? item.routeUrl : 'dynamicPage',
            displayText: item.displayText,
            childMenu: item.ChildMenu,
            params: matchingRoute ? null : { url: item.routeUrl }
        };
    });
}

async function setMenuItems(userId, companyId) {
    const response = await frontEndService.GetHeaderFooterData(userId, companyId, localStorage.getItem("LanguageId") );
    const HeaderFooterList = JSON.parse(Object.values(response.data));
    localStorage.setItem("HeaderFooterList", JSON.stringify(HeaderFooterList));
    HeaderNavlinks.push(JSON.stringify(createMenuItems(HeaderFooterList.HeaderMenuListing)));
    FooterNavlinks.push(JSON.stringify(createMenuItems(HeaderFooterList.FooterMenuListing)));
}

router.beforeEach(async (to, from, next) => {
   
    const specialRoutes = ['errorPage', 'logoutRedirect'];
    if (specialRoutes.includes(to.name)) {
        return next(); 
    }
    let companyDomainName =location.host;
   // let companyDomainName = 'carts.belizeontop.com';
    //let companyDomainName = "www.wheelsbelize.com"//location.host;
    //let companyDomainName ='stagewheelsbelize.kotina.com';
    //let companyDomainName ="stagewheelsbelize.kotina.com"//location.host;
    //let companyDomainName = 'longtermrental.kotina.com';
    //let companyDomainName = 'longtermrental.zorbis.com' //Dark
    //const companyUniqueName = location.host.split('.').shift();
    //let lastIndex = to.path.split('').findIndex((x, i) => { return x == '/' && i > 1 })
    //let companyUniqueName = to.path.substring(1, (lastIndex == -1) ? to.path.length : lastIndex);
   
   
    let companyUniqueName = to.path.split('/')[1] || to.path.substring(1);
   
    if (companyDomainName == localStorage.getItem('domain')) {
        if (localStorage.getItem('HeaderFooterList') == null || localStorage.getItem('HeaderFooterList') == '') {
            await setMenuItems(localStorage.getItem('userId'), localStorage.getItem('companyId'));
        }
        else {
            const HeaderFooterList = localStorage.getItem("HeaderFooterList");
            const filterHeaderFooterList = JSON.parse(HeaderFooterList);
            HeaderNavlinks.push(JSON.stringify(createMenuItems(filterHeaderFooterList.HeaderMenuListing)));
            FooterNavlinks.push(JSON.stringify(createMenuItems(filterHeaderFooterList.FooterMenuListing)));
        }

        await beforeRouteHitMethods(to);
        if (to.hash == '' || to.hash == null) {
            window.scrollTo(0, 0);
        }
        await GetmetaData(to);
        if (to.name == 'undefinded' || typeof to.name == "undefined") {
            to.name = ''
        }
        document.title = `${localStorage.getItem('companyName')} | ` + `${ to.name }`;

        return next();
    }
    else {
        try {
            if (helpers.IsNull(companyDomainName, true, null) == null) {
                throw new Error('Invalid company data');
            }
            if (to.matched.length == 0) {
                throw new Error('Invalid Page');
            }
            if (companyDomainName == 'wheelsbelize.com' || companyDomainName == 'wheelsbelize.com') {
              window.location.href = 'https://www.wheelsbelize.com';
            }
          
            if (localStorage.getItem('CurrentCompDomain') == null || localStorage.getItem('CurrentCompDomain') == "") {
                const companyDetailsResponse = await frontEndService.GetCompanyDetailsByDomainOrName(companyDomainName, companyUniqueName, '', '');

                if (companyDetailsResponse.data.statusCode !== 200) {
                    throw new Error('Company details not found');
                }

                const companyData = companyDetailsResponse.data.result;
                await SetData(companyData, to.name, companyUniqueName);

                await setMenuItems(companyData.userId, companyData.companyId);

                await beforeRouteHitMethods(to);
            }
            else if (localStorage.getItem('CurrentCompDomain') != location.host) {
                const companyDetailsResponse = await frontEndService.GetCompanyDetailsByDomainOrName(companyDomainName, companyUniqueName, '', '');

                if (companyDetailsResponse.data.statusCode !== 200) {
                    throw new Error('Company details not found');
                }

                const companyData = companyDetailsResponse.data.result;
                await SetData(companyData, to.name, companyUniqueName);

                await setMenuItems(companyData.userId, companyData.companyId);

                await beforeRouteHitMethods(to);
            }
            else {
                const HeaderFooterList = localStorage.getItem("HeaderFooterList");
                if (HeaderFooterList == null) {
                    const companyDetailsResponse = await frontEndService.GetCompanyDetailsByDomainOrName(companyDomainName, companyUniqueName, '', '');

                    if (companyDetailsResponse.data.statusCode !== 200) {
                        throw new Error('Company details not found');
                    }

                    const companyData = companyDetailsResponse.data.result;
                    await SetData(companyData, to.name, companyUniqueName);

                    await setMenuItems(companyData.userId, companyData.companyId);

                    await beforeRouteHitMethods(to);
                } else {
                    const filterHeaderFooterList = JSON.parse(HeaderFooterList);
                    HeaderNavlinks.push(JSON.stringify(createMenuItems(filterHeaderFooterList.HeaderMenuListing)));
                    FooterNavlinks.push(JSON.stringify(createMenuItems(filterHeaderFooterList.FooterMenuListing)));
                }
               
            }
            
            if (to.hash == '' || to.hash == null) {
                window.scrollTo(0, 0);
            }
            setTimeout(function () {
                 GetmetaData(to);

            }, 10000);
           

            return next();



        }
        catch (error) {
            console.error(error);
            return next('/errorPage');
        }

    }
})

async function SetData(companyData, title, companyUniqueName) {
    localStorage.removeItem('companyId');
    localStorage.removeItem('companyName');
    localStorage.removeItem('comp-userId');
    localStorage.removeItem('companyURL');
    localStorage.removeItem('companyLogo');
    localStorage.removeItem('theme');
    localStorage.removeItem('companyAddress');
    localStorage.removeItem('showAssetViewIcon');
    localStorage.removeItem('domain');
    localStorage.removeItem('currency');
    localStorage.removeItem('TimeZone');
    localStorage.removeItem('CurrentCompDomain');

    
    localStorage.setItem('companyId', companyData.companyId);
    localStorage.setItem('companyName', companyData.companyName);
    localStorage.setItem('comp-userId', companyData.userId);
    localStorage.setItem('companyURL', companyUniqueName);
    localStorage.setItem('companyLogo', companyData.companyPrimaryLogo ? companyData.companyPrimaryLogo : companyData.companySecondaryLogo);
    localStorage.setItem('companySecondaryLogo', companyData.companySecondaryLogo ? companyData.companySecondaryLogo : companyData.companyPrimaryLogo);
    localStorage.setItem('theme', companyData.theme); //companyData.theme
    localStorage.setItem('currency', companyData.currency);
    localStorage.setItem('CurrentCompDomain', location.host);

    localStorage.setItem('companyAddress', companyData.companyAddress);
    localStorage.setItem('showAssetViewIcon', companyData.assetViews);
    if (localStorage.getItem('Language') == 'en' || localStorage.getItem('Language') == null) {
        localStorage.setItem("LanguageId", '364697eb-c5d6-44fa-8c08-ece45aed1844');
        localStorage.setItem("Language", 'en');
    } else {
        localStorage.setItem("LanguageId", 'cdf82d9b-07af-427e-9261-a3f45bc98f8f');
        localStorage.setItem("Language", 'spanish');
    }
    localStorage.setItem('TimeZone', companyData.timeZone);
    //Check for login in user belong to current company or not 
    if (localStorage.getItem('userinfo') != null && localStorage.getItem('userinfo') != undefined) {
        let userDataJSON = JSON.parse(localStorage.getItem('userinfo'));
        let companyId = userDataJSON.data ? userDataJSON.data.companyId : userDataJSON.companyId;
        if (companyId != localStorage.getItem('companyId').toLowerCase()) {
            localStorage.removeItem("comp-userId");
        }
    }

    setTimeout(function () {
        if (localStorage.getItem('theme') == 'GolfCart') {
            var getId = document.getElementById("golf_cart_not_visible")
            if (getId != null) {
                getId.classList.remove("page-wrapper");
            }
        }
    }, 4000);
    if (title == 'undefinded' || typeof title == "undefined") {
        title = ''
    }
    document.title = `${companyData.companyName} | ` + `${title}`;
    return true


}

// this fuction will check for side compare bar close fucntionality 
async function beforeRouteHitMethods(to) {
    var compareElement = document.getElementById('comparisonblock');
    if (to.name.indexOf('HomePage') == 0 || to.name.indexOf('Listings') == 0) {
    }
    else {
        if (compareElement != null) {
            compareElement.classList.remove('open');
        }
    }
    return
}

async function GetmetaData(to) {
    let metaModel = {
        PageTitle: to.name,
        PageUrl: to.href.replace('/', ''),
        companyId: localStorage.getItem('companyId')
    }
    const response = await frontEndService.GetdynamicMetadata(metaModel);
    debugger;
    if (response.data) {

        const { MetaKeyword, MetaDescription, MetaAuthor } = response.data;

        // Set Meta Keywords
        if (MetaKeyword) {
            document.getElementById('keyword')
                ?.setAttribute("content", MetaKeyword);
        }

        // Set Meta Description
        if (MetaDescription) {
            document.getElementById('description')
                ?.setAttribute("content", MetaDescription);
        }

        // Set Meta Author & Title
        if (MetaAuthor) {
            document.getElementById('title')
                ?.setAttribute("content", MetaAuthor);

            document.title = MetaAuthor;
          
        }

        // Viewport handling
        var screen = window.outerWidth;

        if (screen > 1080) {
            document.getElementById('viewport')
                ?.setAttribute("content", "width=device-width,initial-scale=1");
        } else {
            document.getElementById('viewport')
                ?.setAttribute("content", "width=device-width,initial-scale=1, user-scalable=no");
        }
    }
   
}


export default router